const urls = {
  TRANSLATION_URL: "https://pjp3f7szhl.execute-api.eu-west-1.amazonaws.com/prod/translations",
  AUTH_URL: `https://${process.env.REACT_APP_AUTH_API_BASE_URL}.execute-api.eu-west-1.amazonaws.com/${process.env.REACT_APP_STAGE_MODE}/`,
  REST_URL: `https://${process.env.REACT_APP_REST_API_BASE_URL}.execute-api.eu-west-1.amazonaws.com/${process.env.REACT_APP_STAGE}/`,

}

export default urls;
